import { createTheme } from "@mui/material/styles";

export const getTheme = (mode) =>
  createTheme({
    typography: {
      fontFamily: "Inter, sans-serif", // Ensure MUI components use Inter
      //fontWeightMedium: 100, // Set default weight for medium font
    },
    palette: {
      mode,
      custom: {
        hoverColor: mode === "light" ? "#baa4de" : "#2a4f6e", 
      },
      ...(mode === "light"
        ? {
            primary: {
              main: "#874EF6",
            },
            secondary: {
              main: "#002446",
            },
          }
        : {
            primary: {
              main: "#90caf9",
            },
            secondary: {
              main: "#2a4f6e",
            },
            background: {
              default: "#121212",
              paper: "#1d1d1d",
            },
            text: {
              primary: "#ffffff",
              secondary: "#b3b3b3",
            },
          }),
    },
    Bars: {
      mode,
      custom: {
        hoverColor: mode === "light" ? "#baa4de" : "#2a4f6e", // ✅ Define custom hoverColor
      },
      ...(mode === "light"
        ? {
            main: "#D9B8FF",
            secondary: "#874EF6"
          }
        : {
            main: "#90caf9",
            secondary: "#90caf9",
          }),
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            "&:hover": { 
              backgroundColor: mode === "light" ? "#baa4de" : "#2a4f6e", // Set to blue in light mode, custom color in dark mode
            },
          },
        },
      },
    },
  });
